import Navbar from "../../components/Navbar";

const ContactPage = () => {
  return (
    <div className="container-fluid bg-dark App" style={{ color: "white" }}>
      <Navbar />
      <h2 style={{ padding: 20 }}>discord: bowashe</h2>
      <p style={{ padding: 20 }}>
        While i check osu!chat from time to time, discord is your best bet for
        fastest reposnse.
      </p>
    </div>
  );
};

export default ContactPage;
